<div fxLayout="column" fxFlexFill class="content-container" fxLayoutGap="5px">
  <app-grid-filter placeholder="Type '/' to bring up a list of available filters"
                   [filterOptions]="filterOptions" (filterChangeEvent)="onFilterChanged($event)">
    <app-filter-row-additional-content>
      <div fxLayout="row" fxLayoutGap="5px">
        <a mat-raised-button color="primary" *ngIf="hasEditAccess"
           [routerLink]="[detailsUrl, 'edit', 'new']" matTooltip="Create an auto reply">
          + Add Auto Reply
        </a>
        <a mat-raised-button color="primary" *ngIf="hasEditAccess"
           [routerLink]="[detailsUrl, 'edit-schedule', 'new']" matTooltip="Create scheduled message">
          + Add Schedule
        </a>
      </div>
    </app-filter-row-additional-content>
  </app-grid-filter>

  <div fxFlex class="stretched-container">
    <app-automation-list-grid [filterChangeEvent]="filterChangeEvent"></app-automation-list-grid>
  </div>
</div>
